const cSTOCK = [
    {
        status: 1,
        statusName: "R2 Pickup",
    },
    {
        status: 2,
        statusName: "Picking Up",
    },
    {
        status: 3,
        statusName: "R2 Data",
    },
    {
        status: 4,
        statusName: "Ready Stock",
    },
    {
        status: 5,
        statusName: "R2 Prepare",
    },
    {
        status: 6,
        statusName: "Out Stock",
    },
    {
        status: 7,
        statusName: "Trouble Stock",
    },
    {
        status: 8,
        statusName: "Sold Stock",
    },
    {
        status: 9,
        statusName: "Reso Booked",
    },
];
const cCONDITION = [
    {
        status: 1,
        statusName: "New",
    },
    {
        status: 2,
        statusName: "Refurbished",
    }
];
const cPRODUCT_TYPE = [
    {
        status: 1,
        statusName: "Laptop",
        unit:true
    },
    {
        status: 2,
        statusName: "CPU",
        unit:true
    },
    {
        status: 3,
        statusName: "Monitor",
        unit:true
    },
    {
        status: 4,
        statusName: "Printer",
        unit:true
    },
    {
        status: 5,
        statusName: "Smartphone",
        unit:true
    },
    {
        status: 6,
        statusName: "Tablet",
        unit:true
    },
    {
        status:7,
        statusName: "Monitor Stand",
        unit:false
    },
    {
        status: 8,
        statusName: "Keyboard",
         unit:false
    },
    {
        status:9,
        statusName: "Mouse",
         unit:false
    },
    {
        status: 10,
        statusName: "Silicon Tablet",
         unit:false
    },
    {
        status:11,
        statusName: "Flashdisk",
         unit:false
    },
    {
        status: 12,
        statusName: "VGA Cable",
         unit:false
    },
    {
        status:13,
        statusName: "Power Cable",
         unit:false
    },
    {
        status: 14,
        statusName: "Charger",
         unit:false
    },
    {
        status:15,
        statusName: "Converter",
         unit:false
    },
    {
        status: 16,
        statusName: "Stecker",
         unit:false
    },
    {
        status:17,
        statusName: "Battery",
         unit:false
    },
    {
        status: 18,
        statusName: "Processor",
         unit:false
    },
    {
        status:19,
        statusName: "Thermal Paste",
         unit:false
    },
    {
        status: 20,
        statusName: "RAM",
         unit:false
    },
    {
        status:21,
        statusName: "HDD",
         unit:false
    },
    {
        status: 22,
        statusName: "SSD",
         unit:false
    },
    {
        status: 23,
        statusName: "VGA",
         unit:false
     },
    {
        status: 24,
        statusName: "NVMe",
         unit:false
    },
    {
        status: 25,
        statusName: "Bundling",
         unit:false
    },
];
const cCATALOG_CATEGORY = [
    {
        status: 1,
        statusName: "Administration",
    },
    {
        status: 2,
        statusName: "Business",
    },
    {
        status: 3,
        statusName: "Developer",
    },
    {
        status: 4,
        statusName: "Graphic Design",
    },
    {
        status: 5,
        statusName: "New Condition",
    }
];
const cCATALOG_TYPE = [
    {
        status: 0,
        statusName: "Unit",
    },
    {
        status:1 ,
        statusName: "Bundling",
    }
];
const cCATALOG_STATUS = [
    {
        status:1,
        statusName: "Active",
    },
    {
        status: 0,
        statusName: "Inactive",
    }
];
const cAll = [
    {
        status:"All",
        statusName: "All",
    }
];
const cNew = [
    {
        status:"New",
        statusName: "Create New",
    }
];

const cCOMPLETENESS = [
    {
        status: 0,
        statusName: "Without Storage",
    },
    {
        status: 1,
        statusName: "Full Specifications",
    }
];

const cSOURCE = [
    {
        status: 0,
        statusName: "Order",
    },
    {
        status: 1,
        statusName: "Return",
    },
    {
        status: 2,
        statusName: "Support Bag",
    },
    {
        status: 3,
        statusName: "Other Warehouse",
    },
    {
        status: 4,
        statusName: "Assembly",
    },
    {
        status: 5,
        statusName: "Complain",
    },
    {
        status: 6,
        statusName: "Procurement",
    },
    {
        status: 7,
        statusName: "Stock Opname",
    },
];

const Constants = {
    ALL: cAll,
    NEW: cNew,

    // STOCK STATUS
    STOCK_READY_TO_PICKUP: cSTOCK[0],
    STOCK_PICKING_UP: cSTOCK[1],
    STOCK_READY_TO_DATA: cSTOCK[2],
    STOCK_READY_STOCK: cSTOCK[3],
    STOCK_READY_TO_PREPARE: cSTOCK[4],
    STOCK_OUT_STOCK: cSTOCK[5],
    STOCK_TROUBLE_STOCK: cSTOCK[6],
    STOCK_SOLD_STOCK: cSTOCK[7],
    STOCK_STATUS: cSTOCK,

    // CONDITION
    CONDITION_NEW: cCONDITION[0],
    CONDITION_REFURBISHED: cCONDITION[1],
    CONDITION: cCONDITION,

    // PRODUCT TYPE
    PRODUCT_TYPE_LAPTOP: cPRODUCT_TYPE[0],
    PRODUCT_TYPE_PC_SET: cPRODUCT_TYPE[1],
    PRODUCT_TYPE_MONITOR: cPRODUCT_TYPE[2],
    PRODUCT_TYPE_PRINTER: cPRODUCT_TYPE[3],
    PRODUCT_TYPE_SMARTPHONE: cPRODUCT_TYPE[4],
    PRODUCT_TYPE_TABLET: cPRODUCT_TYPE[5],
    PRODUCT_TYPE: cPRODUCT_TYPE,

    // PRODUCT CATEGORY
    CATALOG_CATEGORY_ADMINISTRATION: cCATALOG_CATEGORY[0],
    CATALOG_CATEGORY_BUSINESS: cCATALOG_CATEGORY[1],
    CATALOG_CATEGORY_DEVELOPER: cCATALOG_CATEGORY[2],
    CATALOG_CATEGORY_GRAPHIC: cCATALOG_CATEGORY[3],
    CATALOG_CATEGORY_NEW: cCATALOG_CATEGORY[4],
    CATALOG_CATEGORY: cCATALOG_CATEGORY,

    // CATALOG TYPE
    CATALOG_TYPE_UNIT: cCATALOG_TYPE[0],
    CATALOG_TYPE_BUNDLING: cCATALOG_TYPE[1],
    CATALOG_TYPE: cCATALOG_TYPE,

    // CATALOG STATUS
    CATALOG_STATUS_ACTIVE: cCATALOG_STATUS[0],
    CATALOG_STATUS_INACTIVE: cCATALOG_STATUS[1],
    CATALOG_STATUS: cCATALOG_STATUS,

    //COMPLETENESS
    COMPLETENESS_WITHOUT_STORAGE: cCOMPLETENESS[0],
    COMPLETENESS_FULL: cCOMPLETENESS[1],
    COMPLETENESS: cCOMPLETENESS,

    // SOURCE
    SOURCE_FROM_ORDER: cSOURCE[0],
    SOURCE_FROM_RETURN: cSOURCE[1],
    SOURCE_FROM_BAG: cSOURCE[2],
    SOURCE_FROM_OTHER_WAREHOUSE: cSOURCE[3],
    SOURCE_FROM_ASSEMBLY: cSOURCE[4],
    SOURCE_FROM_COMPLAIN: cSOURCE[5],
    SOURCE_FROM_PROCUREMENT: cSOURCE[6],
    SOURCE_FROM_STOCK_OPNAME: cSOURCE[7],
    SOURCE_STATUS: cSOURCE,
};

Constants.install = function (Vue) {
    Vue.prototype.$getConst = (key) => {
        // to get Constant from constant string name. ex = 'PRODUCT_TYPE'
        return Constants[key];
    };
    Vue.prototype.$getConstants = (constantsName, valueAddAll) => {
        // to get Constant from constant string name. ex = 'PRODUCT_TYPE'
        // valueAddAll : include all / no
        return Vue.prototype.$getConstantsFromList(Constants[constantsName], valueAddAll);
    };
    Vue.prototype.$getConstantsFromList = (mList, valueAddAll) => {
        // HELPER FUNCTION -- to add 'all' value or not
        // valueAddAll : include all / no
        if(valueAddAll=='all') {
            var dummy  = cAll;
            return dummy.concat(mList);
        }else if(valueAddAll=='new'){
            var dummy  = cNew;
            return mList.concat(dummy);
        }else if(valueAddAll=='new all'){
            var dummy  = mList.concat(cNew);
            var dummy2  = cAll;
            return dummy2.concat(mList);
        }
        return mList;
    };
    Vue.prototype.$getConstantsObjectS = (constantsName, value) => {
        // to get Object from constant string name. ex = 'PRODUCT_TYPE'
        // mList : list of constants
        // valueStatus : its status
        var dummy = Constants[constantsName];
        return Vue.prototype.$getConstantsObjectL(dummy, value);
    };
    Vue.prototype.$getConstantsObjectL = (mList, valueStatus) => {
        // to get Object from List
        // mList : list of constants
        // valueStatus : its status
        var dummy = cAll.concat(mList);
        for(var i=0;i<dummy.length;i++){
            if(dummy[i].status == valueStatus){
                return dummy[i];
            }
        }
        return cAll;
    };
    Vue.prototype.$getConstantsName = (constantsName, status) => {
        // get constant statusName
        var dummy = Constants[constantsName];
        for(var i=0;i<dummy.length;i++){
            if(dummy[i].status == status){
                return dummy[i].statusName;
            }
        }
        return "Can't find "+status;
    };
    Vue.prototype.$getProductType = (valueType, valueAddAll) => {
        // valueType : all / unit / no
        // valueAddAll : include all / no
        var dummy = cPRODUCT_TYPE;
        var result=[];
        if(valueType == "all"){
            return Vue.prototype.$getConstantsFromList(dummy, valueAddAll);
        }else {
            for(var i=0;i<dummy.length;i++){
                if(valueType == "unit" && dummy[i].unit){
                    result.push(dummy[i]);
                }else if(valueType != "unit" && !dummy[i].unit){
                     result.push(dummy[i]);
                }
            }
        }
        // console.log(localStorage.getItem("itemPerPage"))
        return Vue.prototype.$getConstantsFromList(result, valueAddAll);
    };
    Vue.prototype.$getSpecificationText = (jsondetail, productType) => {
        var jDetail = JSON.parse(jsondetail)
        var specification = "lalala"
        if (productType == '1' || productType == '2') {
            specification = jDetail.processor + '/' + jDetail.ram + 'GB/' + jDetail.storage + '/' + jDetail.vga
        } else if (productType == '3') {
            specification = jDetail.displaySize + ' Inch'
        } else if (productType == '4') {
            specification = jDetail.colorTech
        } else if (productType == '5' || productType == '6') {
            specification = jDetail.processor + '/' + jDetail.ram + 'GB/' + jDetail.storage
        }else{
            specification = jDetail.specifications
        }
        return specification;
    };

    Vue.prototype.$getSpecParsing = (spec, key, specType) => {
        var result=[];
        if (specType == 'actual') {
            if (key == 'processor') {
                result = spec["processor"]
            }else if (key == 'ram') {
                result = spec["ram"]
            }else if (key == 'storage') {
                result = spec["storage"]
            }else if (key == 'vga') {
                result = spec["vga"]
            }
        }else if (specType == 'catalog') {
            if (key == 'brand') {
                result = spec["brand"]
            }else if (key == 'model') {
                result = spec["model"]
            }
        }
        return result;
    };
    Vue.prototype.$canEditComponentByProductType = (productType) => {
        var productTypeList = [Constants["PRODUCT_TYPE_LAPTOP"],Constants["PRODUCT_TYPE_PC_SET"],Constants["PRODUCT_TYPE_MONITOR"],Constants["PRODUCT_TYPE_PRINTER"]]
        var sProductType = parseInt(productType)
        for(var ii =0; ii<productTypeList.length; ii++){
            if(sProductType==productTypeList[ii].status){
                return false
            }
        }
        return true
    };
};
export default Constants;



// WEBPACK FOOTER //
// ./src/components/constPlugin.js